import {ActivityIndicator} from "react-native";
import Page from "@/lib/components/Page";
import {Color} from "@/lib/styles";
import Center from "@/lib/components/Center";

// Outer wrapper container for all pages.
export default function SpinnerPage() {
    return (
        <Page>
            <Center>
                <ActivityIndicator size="large" color={Color.PrimaryText}/>
            </Center>
        </Page>
    );
}